import { initialState } from "./../initialState";
import * as TasklistActions from "./tasklistActions";

export const tasklistReducer = (state = initialState.tasklist, action) => {
    switch (action.type) {
        case TasklistActions.FILTER_TASKLIST:
            return {
                ...state,
                filters: action.filter,
            };

        default:
            return state;
    }
};
